/**
 * Parse Google Places address_components into checkout form fields.
 * @param {google.maps.GeocoderAddressComponent[]|undefined} components
 * @returns {{ address1: string, city: string, stateOrProvince: string, postalCode: string, countryCode: string }|null}
 */
export function parseGooglePlaceComponents(components) {
	if (!components?.length) return null

	const parsed = components.reduce((acc, component) => {
		const types = component.types
		if (types.includes('street_number')) {
			acc.street_number = component.long_name
		} else if (types.includes('route')) {
			acc.route = component.long_name
		} else if (types.includes('locality')) {
			acc.city = component.long_name
		} else if (types.includes('administrative_area_level_1')) {
			acc.state = component.long_name
		} else if (types.includes('country')) {
			acc.country = component.short_name
		} else if (types.includes('postal_code')) {
			acc.postal_code = component.long_name
		}
		return acc
	}, {})

	return {
		address1: `${parsed.street_number || ''} ${parsed.route || ''}`.trim(),
		city: parsed.city || '',
		stateOrProvince: parsed.state || '',
		postalCode: parsed.postal_code || '',
		countryCode: parsed.country || '',
	}
}
